// extracted by mini-css-extract-plugin
export var buttons = "sectionReviews-module--buttons--bcf35";
export var checkmarkList = "sectionReviews-module--checkmarkList--1d004";
export var container = "sectionReviews-module--container--7de64";
export var name = "sectionReviews-module--name--eb295";
export var nameAndDate = "sectionReviews-module--nameAndDate--ad395";
export var nameAndRating = "sectionReviews-module--nameAndRating--0cd02";
export var ratingsAndButtons = "sectionReviews-module--ratingsAndButtons--1130e";
export var review = "sectionReviews-module--review--863ee";
export var section = "sectionReviews-module--section--77543";
export var showMoreButtons = "sectionReviews-module--showMoreButtons--4211c";
export var topText = "sectionReviews-module--topText--3acda";
export var totalRating = "sectionReviews-module--totalRating--6c347";
export var totalReview = "sectionReviews-module--totalReview--fee5e";
export var totalReviewRatings = "sectionReviews-module--totalReviewRatings--34d03";